export const CANONICAL_ORDER = ['One Size', 'XS', 'SM', 'MD', 'LG', 'XL', 'XXL', 'XXXL'] as const

// Normalisera ungefär som i catalog.ts (förenklad, men täcker mapping)
export function normalizeSizeCode(raw: string): string {
  if (!raw) return ''
  const s = raw.trim().toUpperCase()
  if (['ONE SIZE', 'OS', 'O/S'].includes(s)) return 'One Size'
  if (s === 'XS') return 'XS'
  if (s === 'S' || s === 'SM') return 'SM'
  if (s === 'M' || s === 'MD') return 'MD'
  if (s === 'L' || s === 'LG') return 'LG'
  if (s === 'XL') return 'XL'
  if (s === 'XXL' || s === '2XL') return 'XXL'
  if (s === 'XXXL' || s === '3XL') return 'XXXL'
  return raw.trim()
}

export function sizeSortIndex(size: string): number {
  const norm = normalizeSizeCode(size)
  const idx = CANONICAL_ORDER.indexOf(norm as any)
  return idx === -1 ? 1000 + norm.charCodeAt(0) : idx
}